import { MERCHANT } from "constants/action-types";
import { IMerchantSharedSettings } from "constants/merchant";
import { FluxStandardAction as Action } from "flux-standard-action";

export type GetMerchantSharedSettingsRequestAction = Action<
    {
        merchantId: string;
    },
    {}
>;

export const getMerchantSharedSettingsRequest = (merchantId: string): GetMerchantSharedSettingsRequestAction => ({
    meta: {},
    payload: { merchantId },
    type: MERCHANT.SHARED_SETTINGS.GET.REQUEST,
});

export type GetMerchantSharedSettingsCompleteAction = Action<IMerchantSharedSettings | Error, {}>;

export const getMerchantSharedSettingsComplete = (
    payload: IMerchantSharedSettings | Error
): GetMerchantSharedSettingsCompleteAction => ({
    meta: {},
    payload,
    error: payload instanceof Error,
    type: MERCHANT.SHARED_SETTINGS.GET.COMPLETE,
});
